import { render, staticRenderFns } from "./group-manage.vue?vue&type=template&id=2e8458f4&scoped=true&"
import script from "./group-manage.vue?vue&type=script&lang=js&"
export * from "./group-manage.vue?vue&type=script&lang=js&"
import style0 from "./group-manage.vue?vue&type=style&index=0&id=2e8458f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8458f4",
  null
  
)

export default component.exports